import { initializeApp } from "firebase/app";
import {
    getMessaging,
    isSupported,
    getToken,
    onMessage
} from "firebase/messaging";

const firebaseConfig = {
    apiKey: "AIzaSyDBsQdI_ysRo2mVIdQXk3kZnOplt4xHK38",
    authDomain: "totalfresh-1b41a.firebaseapp.com",
    projectId: "totalfresh-1b41a",
    messagingSenderId: "781024855506",
    appId: "1:781024855506:web:6a5764b893f5bc4a0c740b"
};

export const app = initializeApp(firebaseConfig);

/**
 * Get messaging instance safely
 */
export const getFirebaseMessaging = async () => {
    console.log("isSupported");
    const supported = await isSupported();
    console.log("supported: ", supported);
    if (!supported) return null;
    return getMessaging(app);
};

/**
 * Ask permission & get FCM token
 */
export const requestFcmToken = async () => {
    try {
        const messaging = await getFirebaseMessaging();
        if (!messaging) return null;

        const permission = await Notification.requestPermission();
        if (permission !== "granted") return null;

        const token = await getToken(messaging, {
            vapidKey: "MZjTBwZXWlQKpjLxPka-mtf5DgA0DmrsbEZ4Eb7pFcfL1v4eq4tTLUk9kbDfpCHrFHC5j5lfuzB7TF_1G1H4Q4"
        });

        return token;
    } catch (err) {
        console.error("FCM token error:", err);
        return null;
    }
};

/**
 * Foreground message listener (call ONCE)
 */
export const onForegroundMessage = async (callback) => {
    const messaging = await getFirebaseMessaging();
    if (!messaging) return;

    onMessage(messaging, (payload) => {
        callback(payload);
    });
};